export default {
      id: "ic_tribun_green-usage",
      viewBox: "0 0 19 12",
      url: "/" + "images/icons.3.109.2.svg#ic_tribun_green-usage",
      toString: function () {
        return this.url;
      }
    }